import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { WidgetShell } from "@eudonet/opal";
import { evaluateFieldVisibility } from "@/shared/composables/useFieldVisibility";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderedBlock',
    props: {
        block: {},
        header: {},
        rowGap: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const defaultRule = { visible: true, readonly: false, required: false };
        // Pre-compute visibility for all fields in the block.
        // Evaluated against block.values so conditions reference only fields within this block.
        const visibilityMap = computed(() => {
            const result = {};
            for (const fieldKey of props.block.fieldOrder) {
                const rule = props.block.fieldRules[fieldKey];
                result[fieldKey] = evaluateFieldVisibility(rule, props.block.values);
            }
            return result;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(WidgetShell), { header: __props.header }, _createSlots({
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(["grid grid-cols-2 gap-x-4 -mb-5", { 'gap-y-6': __props.rowGap }])
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.fieldOrder, (fieldKey) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: fieldKey }, [
                                (visibilityMap.value[fieldKey])
                                    ? _renderSlot(_ctx.$slots, fieldKey, {
                                        key: 0,
                                        rules: __props.block.fieldRules[fieldKey] ?? defaultRule
                                    })
                                    : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */));
                        }), 128 /* KEYED_FRAGMENT */))
                    ], 2 /* CLASS */)
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (_ctx.$slots.actions)
                    ? {
                        name: "actions",
                        fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "actions")
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["header"]));
        };
    }
});
